export const shiftMetrics = {
  covers: 142,
  targetCovers: 200,
  avgTurnTime: '48m',
  targetTurnTime: '45m',
  waitlist: 4,
  revenueEst: '$4,250',
  inventoryAlerts: 2,
  laborCost: '18%'
};

export const tables = [
  { id: 'T1', status: 'occupied', capacity: 2, seatedAt: '18:15', server: 'Alex', orders: 3 },
  { id: 'T2', status: 'occupied', capacity: 2, seatedAt: '18:30', server: 'Alex', orders: 2 },
  { id: 'T3', status: 'dirty', capacity: 4, seatedAt: null, server: 'Sam', orders: 0 },
  { id: 'T4', status: 'open', capacity: 4, seatedAt: null, server: 'Sam', orders: 0 },
  { id: 'T5', status: 'reserved', capacity: 2, reservationTime: '19:30', name: 'Smith' },
  { id: 'T6', status: 'occupied', capacity: 6, seatedAt: '17:45', server: 'Jordan', orders: 5 },
  { id: 'T7', status: 'open', capacity: 2, seatedAt: null, server: 'Jordan', orders: 0 },
  { id: 'T8', status: 'occupied', capacity: 4, seatedAt: '18:50', server: 'Alex', orders: 1 },
  { id: 'T9', status: 'dirty', capacity: 2, seatedAt: null, server: 'Sam', orders: 0 },
  { id: 'T10', status: 'open', capacity: 8, seatedAt: null, server: 'Jordan', orders: 0 },
  { id: 'T11', status: 'reserved', capacity: 4, reservationTime: '20:00', name: 'Johnson' },
  { id: 'T12', status: 'occupied', capacity: 2, seatedAt: '19:05', server: 'Alex', orders: 1 },
];

export const prepList = [
  { id: 1, station: 'Grill', item: 'Portion Ribeyes', qty: '20 ea', status: 'pending', priority: 'high' },
  { id: 2, station: 'Pantry', item: 'Wash Greens', qty: '4 cambro', status: 'completed', priority: 'medium' },
  { id: 3, station: 'Sauté', item: 'Reduce Demi-glace', qty: '2 qt', status: 'in-progress', priority: 'low' },
  { id: 4, station: 'Bar', item: 'Cut Citrus Wheels', qty: '1 pan', status: 'pending', priority: 'medium' },
];

export const inventoryNotes = [
  { id: 1, item: 'Wagyu Strip', status: 'low', qty: '4 portions left', action: '86' },
  { id: 2, item: 'Pinot Noir 2018', status: 'out', qty: '0 bottles', action: 'Restock Tomorrow' },
];

export const feedback = [
  { id: 1, rating: 5, text: "Incredible service, steak was perfectly cooked.", table: 'T6', time: '10m ago', guest: 'Marcus V.' },
  { id: 2, rating: 3, text: "A bit loud, food took a while but was good.", table: 'T1', time: '45m ago', guest: 'Sarah J.' },
  { id: 3, rating: 5, text: "Loved the new cocktail menu!", table: 'Bar', time: '1h ago', guest: 'Anon' },
];

export const staffSchedule = [
  { name: 'Alex H.', role: 'Server', time: '16:00 - 00:00', zone: 'Front', status: 'active' },
  { name: 'Sam T.', role: 'Server', time: '17:00 - 01:00', zone: 'Patio', status: 'active' },
  { name: 'Jordan K.', role: 'Lead Server', time: '15:00 - 23:00', zone: 'Main', status: 'break' },
  { name: 'Chef Maria', role: 'Exec Chef', time: '14:00 - 23:00', zone: 'Kitchen', status: 'active' },
  { name: 'David L.', role: 'Bartender', time: '16:00 - 02:00', zone: 'Bar', status: 'on-way' },
];